// components/ToastWrapper.tsx
"use client";

import { useSelector, useDispatch } from "react-redux";
import { hideToast } from "../redux/slices/toastSlice";

export default function ToastWrapper() {
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  if (!toast.visible) return null;

  // setTimeout to auto hide the toast after 3 seconds
  setTimeout(() => {
    dispatch(hideToast());
  }, 3000);

  return (
    <div className={`toast-container position-fixed top-5 end-5`} style={{ zIndex: 1060 }}>
      <div
        className={`toast align-items-center text-bg-${toast.state} border-0 show`}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="d-flex">
          <div className="toast-body">
            {toast.msg}
          </div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
            onClick={() => dispatch(hideToast())}
          ></button>
        </div>
      </div>
    </div>
  );
}
